import { useEffect, useRef } from "react";
import { useProfile, useUpdateProfile } from "@/hooks/useProfile";
import { DEFAULT_COUNTRY_CODE, getCountryConfig, COUNTRIES } from "@/lib/countries";
import { inferCountryCode } from "@/lib/inferCountry";

export function useCountry() {
  const { data: profile } = useProfile();
  const updateProfile = useUpdateProfile();
  const attempted = useRef(false);

  // Auto-set country on profile if it's null (first login)
  useEffect(() => {
    if (!profile || profile.country || attempted.current) return;
    attempted.current = true;

    const inferred = inferCountryCode();
    // Only set if we support this country
    const supported = COUNTRIES.find((c) => c.code === inferred);
    if (supported) {
      updateProfile.mutate({ country: inferred });
    }
  }, [profile]);

  const countryCode = profile?.country ?? DEFAULT_COUNTRY_CODE;
  const country = getCountryConfig(countryCode);

  return {
    profile,
    countryCode,
    country,
  };
}
